import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type AppState = {
  hydrated: boolean;
};

const initialState: AppState = {
  hydrated: false,
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setHydrated: (state, action: PayloadAction<boolean>) => {
      state.hydrated = action.payload;
    },
  },
});

export const { setHydrated } = appSlice.actions;

export default appSlice.reducer;
